<template>
  <div class="header">
    <img class="head" :src="webInfoObj.strPicUrl" alt="" />
    <div class="menu">
      <ul class="flex container">
        <li>
          <div
            @click="indexHandle()"
            :class="'6e7fd15b1b844c088d79269e44fdbd49' == strId ? 'active' : ''"
          >
            <span>专题首页</span>
          </div>
        </li>
        <li v-for="(item, index) in navigations" :key="index">
          <div
            @click="navHandle(item.strId)"
            :class="item.strId == strId ? 'active' : ''"
          >
            <span>{{ item.strName }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { navData } from "@/api/configuration";
import { get } from "../../utils/helpers";
export default {
  name: "Head",
  components: {},
  data() {
    return {
      strId: "",
      navigations: [],
    };
  },
  props: {
    webInfoObj: {
      type: Object,
      default: () => [],
    },
  },
  watch: {
    $route(to, from) {
      this.strId = this.$route.query.strId;
    },
  },
  created() {
    this.getNavData(); // 获取导航数据
  },
  methods: {
    // 首页跳转
    indexHandle() {
      this.$router.push({ path: "/index", query: { strWebSiteId: this.$route.query.strWebSiteId } });
    },

    // 菜单跳转
    navHandle(strId) {
      this.$router.push({ path: "/list", query: { strId: strId, strWebSiteId: this.$route.query.strWebSiteId } });
    },

    // 获取导航数据
    getNavData() {
      navData({ strWebSiteId: this.$store.state.strWebSiteId })
        .then((res) => {
          this.navigations = get(["data", "navigations"], res.data);
        })
        .catch((err) => {
          this.$message.destroy();
          this.$message.error(err);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  box-sizing: border-box;
  position: relative;
  .head {
    display: block;
    width: 100%;
    height: auto;
    margin: 0 auto;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
  }
  .menu {
    width: 1281px;
    position: absolute;
    left: 50%;
    margin-left: -640.5px;
    bottom: -20px;
    height: 90px;
    line-height: 90px;
    background: url('../../assets/images/menu.png') no-repeat center center;
    background-size: 100%;
    overflow: hidden;
    font-family: 'STZhongsong';
    li {
      flex: 1;
      overflow: hidden;
      font-size: 28px;
      text-align: center;
      color: #fff;
      display: block;
      font-weight: bold;
      cursor: pointer;
      span {
        transition: all 0.3s ease-out 0s;
      }
      &:hover {
        color: #F7E5AE;
        background: url('../../assets/images/menu-active.png') no-repeat center center;
        background-size: 100% 100%;
      }
      .active {
        color: #F7E5AE;
        background: url('../../assets/images/menu-active.png') no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
}
</style>